import { useState } from "react";
import DefaultFooter from "../components/default-footer";
import DefaultHeader from "../components/default-header";
import DatePicker, { DateObject } from "react-multi-date-picker";
import Slider from "rc-slider";
import toursData from "./../data/tours";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useParams } from "react-router-dom";
import Tours from "./../components/Tours";
import "photoswipe/dist/photoswipe.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import GoogleMapReact from "google-map-react";
import { FC } from "react";
import ModalVideo from "../components/ModalVideo";
import "rc-slider/assets/index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const counters = [
  { name: "Adults", defaultValue: 2 },
  { name: "Children", defaultValue: 1 },
  { name: "Rooms", defaultValue: 1 },
];

type CounterProps = {
  name: string;
  defaultValue: number;
  onCounterChange: (name: string, value: number) => void;
};

const Counter = ({ name, defaultValue, onCounterChange }: CounterProps) => {
  const [count, setCount] = useState(defaultValue);
  const inc = () => { setCount(count + 1); onCounterChange(name, count + 1); };
  const dec = () => { if (count > 0) { setCount(count - 1); onCounterChange(name, count - 1); } };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0" }}>
        <div>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: "#1a2f38" }}>{name}</div>
          {name === "Children" && <div style={{ fontSize: 11, color: "#7a9aaa", marginTop: 2 }}>Ages 0–17</div>}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button onClick={dec} style={{ width: 30, height: 30, borderRadius: 8, border: "1.5px solid rgba(41,75,90,0.25)", background: "#fff", color: "#294b5a", cursor: "pointer", fontSize: 16 }}>−</button>
          <span style={{ fontSize: 14, fontWeight: 700, color: "#1a2f38", minWidth: 18, textAlign: "center" }}>{count}</span>
          <button onClick={inc} style={{ width: 30, height: 30, borderRadius: 8, border: "none", background: "#294b5a", color: "#fff", cursor: "pointer", fontSize: 16 }}>+</button>
        </div>
      </div>
      <div style={{ height: 1, background: "#eef1f3" }} />
    </div>
  );
};

type MarkerProps = { lat: number; lng: number; text: string };
const MapMarker: FC<MarkerProps> = ({ text }) => (
  <div style={{ background: "#294b5a", color: "#fff", padding: "6px 12px", borderRadius: 8, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", boxShadow: "0 4px 12px rgba(41,75,90,0.3)" }}>
    📍 {text}
  </div>
);

const SingleTrip = () => {
  const [guestCounts, setGuestCounts] = useState({ Adults: 2, Children: 1, Rooms: 1 });
  const handleCounterChange = (name: any, value: any) => setGuestCounts((p) => ({ ...p, [name]: value }));
  const [dates, setDates] = useState([new DateObject().setDay(5), new DateObject().setDay(14).add(1, "month")]);
  const [isOpen, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");

  const { id } = useParams<{ id: string }>();
  const tour = toursData.find((item) => item.id === Number(id)) || toursData[0];

  const defaultProps = { center: { lat: 10.99835602, lng: 77.01502627 }, zoom: 11 };

  const itineraryContent = [
    { id: 1, targetCollapse: "item_1", itemNo: "1", title: "Windsor Castle", img: "/img/tours/list.png", content: "Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years.", classShowHide: "" },
    { id: 2, targetCollapse: "item_2", itemNo: "2", title: "St. George's Chapel", img: "/img/tours/list.png", content: "Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years.", classShowHide: "show" },
    { id: 3, targetCollapse: "item_3", itemNo: "3", title: "The Roman Baths", img: "/img/tours/list.png", content: "Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years.", classShowHide: "" },
    { id: 4, targetCollapse: "item_4", itemNo: "4", title: "Stonehenge", img: "/img/tours/list.png", content: "Our first stop is Windsor Castle, the ancestral home of the British Royal family for more than 900 years.", classShowHide: "" },
  ];

  const reviewProgress = [
    { id: 1, label: "Location", value: 9.4, pct: "94%" },
    { id: 2, label: "Staff", value: 8.4, pct: "84%" },
    { id: 3, label: "Cleanliness", value: 9.4, pct: "94%" },
    { id: 4, label: "Value for money", value: 8.0, pct: "80%" },
    { id: 5, label: "Comfort", value: 9.4, pct: "94%" },
    { id: 6, label: "Facilities", value: 8.5, pct: "85%" },
  ];

  const reviewGalleryImg = ["/img/testimonials/1/1.png", "/img/testimonials/1/2.png", "/img/testimonials/1/3.png", "/img/testimonials/1/4.png"];
  const snapshots = [
    { icon: "icon-clock", label: "Duration", value: "11 hours" },
    { icon: "icon-customer", label: "Group size", value: "52 people" },
    { icon: "icon-route", label: "Transport", value: "Public-friendly" },
    { icon: "icon-access-denied", label: "Cancellation", value: "Free, 24h" },
  ];

  const navTabs = ["overview", "itinerary", "included", "reviews", "map"];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

        .st-page { font-family: 'Jost', sans-serif; background: #fff; color: #2d3f48; }

        /* HERO */
        .st-hero {
          position: relative; background: #1a2f38;
          padding: 40px 0 0;
        }
        .st-hero__top {
          display: flex; align-items: flex-start;
          justify-content: space-between; flex-wrap: wrap;
          gap: 16px; padding-bottom: 24px;
        }
        .st-hero__eyebrow {
          display: inline-flex; align-items: center; gap: 8px;
          font-size: 10px; font-weight: 600; letter-spacing: 3px;
          text-transform: uppercase; color: #D3BE76; margin-bottom: 10px;
        }
        .st-hero__eyebrow::before { content: ''; width: 26px; height: 1.5px; background: #D3BE76; display: block; }
        .st-hero h1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(26px, 3.5vw, 42px);
          font-weight: 700; color: #fff; line-height: 1.2; margin: 0 0 12px;
        }
        .st-hero__meta {
          display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
        }
        .st-hero__meta-item {
          display: flex; align-items: center; gap: 6px;
          font-size: 13px; color: rgba(255,255,255,0.6);
        }
        .st-hero__meta-item i { color: #D3BE76; font-size: 14px; }
        .st-hero__actions { display: flex; gap: 10px; }
        .st-action-btn {
          display: inline-flex; align-items: center; gap: 7px;
          padding: 9px 18px; border-radius: 10px;
          border: 1.5px solid rgba(255,255,255,0.2);
          background: transparent; color: rgba(255,255,255,0.8);
          font-family: 'Jost', sans-serif; font-size: 12px; font-weight: 600;
          letter-spacing: 1px; text-transform: uppercase; cursor: pointer;
          transition: all 0.2s;
        }
        .st-action-btn:hover { border-color: #D3BE76; color: #D3BE76; }

        /* STICKY NAV */
        .st-nav {
          background: #1a2f38; border-top: 1px solid rgba(255,255,255,0.08);
          position: sticky; top: 0; z-index: 100;
        }
        .st-nav__inner {
          display: flex; gap: 0; overflow-x: auto;
        }
        .st-nav__btn {
          padding: 16px 22px; font-size: 12px; font-weight: 600;
          letter-spacing: 1.5px; text-transform: uppercase;
          color: rgba(255,255,255,0.45); border: none; background: none;
          cursor: pointer; white-space: nowrap; position: relative;
          transition: color 0.2s; font-family: 'Jost', sans-serif;
          border-bottom: 2px solid transparent;
        }
        .st-nav__btn.active { color: #D3BE76; border-bottom-color: #D3BE76; }
        .st-nav__btn:hover { color: rgba(255,255,255,0.8); }

        /* GALLERY */
        .st-gallery { position: relative; overflow: hidden; border-radius: 0; }
        .st-gallery img { width: 100%; height: 500px; object-fit: cover; display: block; }
        .st-gallery__overlay-btn {
          position: absolute; bottom: 20px; right: 20px;
          background: rgba(255,255,255,0.95); backdrop-filter: blur(4px);
          padding: 10px 20px; border-radius: 10px;
          font-size: 12px; font-weight: 700; letter-spacing: 1.5px;
          text-transform: uppercase; color: #294b5a; cursor: pointer;
          border: none; display: flex; align-items: center; gap: 8px;
          transition: background 0.2s;
        }
        .st-gallery__overlay-btn:hover { background: #fff; }

        /* SNAPSHOT */
        .st-snapshot {
          display: grid; grid-template-columns: repeat(4, 1fr);
          gap: 1px; background: #e8eef1;
          border-radius: 14px; overflow: hidden;
          margin: 32px 0;
        }
        .st-snapshot__item {
          background: #faf8f3; padding: 20px 24px;
          display: flex; align-items: center; gap: 14px;
        }
        .st-snapshot__icon {
          width: 40px; height: 40px; border-radius: 10px;
          background: rgba(41,75,90,0.08);
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .st-snapshot__icon i { color: #294b5a; font-size: 18px; }
        .st-snapshot__label { font-size: 11px; color: #7a9aaa; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 3px; }
        .st-snapshot__val { font-size: 14px; font-weight: 600; color: #1a2f38; }

        /* SECTION TITLES */
        .st-section-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 26px; font-weight: 700; color: #1a2f38;
          margin-bottom: 18px; position: relative; padding-bottom: 12px;
        }
        .st-section-title::after {
          content: ''; position: absolute; bottom: 0; left: 0;
          width: 36px; height: 2px; background: #D3BE76;
        }

        /* CONTENT TEXT */
        .st-body-text { font-size: 15px; line-height: 1.85; color: #4a6370; }
        .st-highlight-list { list-style: none; padding: 0; margin: 16px 0 0; }
        .st-highlight-list li {
          font-size: 14.5px; color: #4a6370; padding: 6px 0 6px 20px;
          position: relative; line-height: 1.6;
        }
        .st-highlight-list li::before {
          content: ''; position: absolute; left: 0; top: 13px;
          width: 8px; height: 1.5px; background: #D3BE76;
        }

        /* INCLUDED */
        .st-included-item {
          display: flex; align-items: flex-start; gap: 10px;
          font-size: 14.5px; color: #4a6370; margin-bottom: 10px;
        }
        .st-included-item .check { color: #27796e; font-size: 13px; margin-top: 2px; }
        .st-included-item .cross { color: #c0cdd2; font-size: 13px; margin-top: 2px; }

        /* INFO GRID */
        .st-info-card {
          background: #faf8f3; border-radius: 14px; padding: 24px;
          border-left: 3px solid #D3BE76; height: 100%;
        }
        .st-info-card__title { font-size: 13px; font-weight: 700; color: #294b5a; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 14px; }
        .st-info-list { list-style: none; padding: 0; margin: 0; }
        .st-info-list li { font-size: 14px; color: #4a6370; padding: 5px 0; border-bottom: 1px dashed #e8eef1; line-height: 1.6; }
        .st-info-list li:last-child { border-bottom: none; }

        /* ITINERARY */
        .st-stop {
          display: flex; gap: 16px; padding-bottom: 28px;
          position: relative;
        }
        .st-stop::before {
          content: ''; position: absolute;
          left: 19px; top: 40px; bottom: 0;
          width: 1px; background: linear-gradient(to bottom, #D3BE76, transparent);
        }
        .st-stop:last-child::before { display: none; }
        .st-stop__num {
          width: 40px; height: 40px; border-radius: 50%;
          background: #294b5a; color: #D3BE76;
          display: flex; align-items: center; justify-content: center;
          font-family: 'Cormorant Garamond', serif;
          font-size: 16px; font-weight: 700; flex-shrink: 0;
        }
        .st-stop__title {
          font-size: 15px; font-weight: 600; color: #1a2f38; margin-bottom: 3px;
        }
        .st-stop__sub { font-size: 12.5px; color: #7a9aaa; margin-bottom: 8px; }
        .st-stop__toggle {
          font-size: 12px; font-weight: 600; color: #294b5a;
          letter-spacing: 1px; text-transform: uppercase;
          background: none; border: none; cursor: pointer; padding: 0;
          display: flex; align-items: center; gap: 6px;
          transition: color 0.2s;
        }
        .st-stop__toggle:hover { color: #D3BE76; }

        /* BOOKING WIDGET */
        .st-book-widget {
          background: #fff; border-radius: 18px;
          border: 1px solid #e8eef1;
          box-shadow: 0 12px 40px rgba(41,75,90,0.1);
          overflow: hidden; position: sticky; top: 80px;
        }
        .st-book-widget__head {
          background: #1a2f38; padding: 24px 28px;
        }
        .st-book-widget__from { font-size: 11px; color: rgba(255,255,255,0.5); letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 6px; }
        .st-book-widget__price {
          font-family: 'Cormorant Garamond', serif;
          font-size: 40px; font-weight: 700; color: #fff; line-height: 1;
        }
        .st-book-widget__price span { font-size: 16px; color: rgba(255,255,255,0.5); margin-left: 6px; }
        .st-book-widget__body { padding: 24px 28px; }
        .st-field {
          border: 1.5px solid #e0e8ec; border-radius: 12px;
          padding: 14px 16px; margin-bottom: 12px;
          background: #faf8f3; transition: border-color 0.2s;
        }
        .st-field:focus-within { border-color: #294b5a; background: #fff; }
        .st-field__label {
          font-size: 10px; font-weight: 700; letter-spacing: 2px;
          text-transform: uppercase; color: #294b5a; margin-bottom: 5px;
        }
        .st-field__val { font-size: 13.5px; color: #4a6370; }
        .st-book-btn {
          display: block; width: 100%; padding: 16px;
          background: linear-gradient(135deg, #294b5a 0%, #1a2f38 100%);
          color: #fff; border: none; border-radius: 12px;
          font-family: 'Jost', sans-serif; font-size: 13px; font-weight: 700;
          letter-spacing: 2px; text-transform: uppercase; cursor: pointer;
          transition: opacity 0.2s, transform 0.2s; margin-top: 4px;
          text-align: center; text-decoration: none;
        }
        .st-book-btn:hover { opacity: 0.9; transform: translateY(-1px); color: #fff; }
        .st-trust {
          display: flex; align-items: flex-start; gap: 10px;
          padding: 16px 28px 20px; background: rgba(211,190,118,0.06);
          border-top: 1px solid #eef1f3;
        }
        .st-trust__icon { color: #D3BE76; font-size: 18px; margin-top: 2px; }
        .st-trust__text { font-size: 12.5px; color: #7a9aaa; line-height: 1.6; }

        /* REVIEWS */
        .st-score-badge {
          width: 60px; height: 60px; border-radius: 14px;
          background: #294b5a; color: #D3BE76;
          display: flex; align-items: center; justify-content: center;
          font-family: 'Cormorant Garamond', serif;
          font-size: 24px; font-weight: 700; flex-shrink: 0;
        }
        .st-prog-bar { height: 6px; background: #eef1f3; border-radius: 3px; margin-top: 8px; overflow: hidden; }
        .st-prog-bar__fill { height: 100%; background: linear-gradient(90deg, #294b5a, #D3BE76); border-radius: 3px; }
        .st-review-item { padding: 24px 0; border-bottom: 1px solid #eef1f3; }
        .st-review-item:last-of-type { border-bottom: none; }
        .st-review__header { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
        .st-review__avatar { width: 44px; height: 44px; border-radius: 50%; object-fit: cover; }
        .st-review__name { font-size: 14px; font-weight: 600; color: #1a2f38; }
        .st-review__date { font-size: 12px; color: #7a9aaa; }
        .st-review__score-pill {
          display: inline-flex; align-items: center; gap: 5px;
          background: rgba(41,75,90,0.07); color: #294b5a;
          font-size: 12px; font-weight: 700;
          padding: 4px 12px; border-radius: 30px; margin-bottom: 8px;
        }
        .st-review__text { font-size: 14.5px; color: #4a6370; line-height: 1.75; }
        .st-review__actions { display: flex; gap: 16px; margin-top: 12px; }
        .st-review__action {
          display: flex; align-items: center; gap: 6px;
          font-size: 12.5px; font-weight: 500; cursor: pointer;
          border: none; background: none; padding: 0; transition: color 0.2s;
        }
        .st-review__action.helpful { color: #294b5a; }
        .st-review__action.helpful:hover { color: #D3BE76; }
        .st-review__action.nope { color: #c0cdd2; }
        .st-review__action.nope:hover { color: #294b5a; }

        /* FORM */
        .st-form-field { position: relative; margin-bottom: 0; }
        .st-form-field input, .st-form-field textarea {
          width: 100%; padding: 18px 16px 8px;
          border: 1.5px solid #e0e8ec; border-radius: 12px;
          font-family: 'Jost', sans-serif; font-size: 14.5px; color: #1a2f38;
          outline: none; background: #faf8f3; resize: none;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .st-form-field input:focus, .st-form-field textarea:focus {
          border-color: #294b5a; background: #fff;
          box-shadow: 0 0 0 3px rgba(41,75,90,0.07);
        }
        .st-form-field label {
          position: absolute; left: 16px; top: 14px;
          font-size: 13px; color: #7a9aaa; pointer-events: none;
          transition: all 0.2s;
        }
        .st-form-field input:focus ~ label, .st-form-field input:valid ~ label,
        .st-form-field textarea:focus ~ label, .st-form-field textarea:valid ~ label {
          top: 5px; font-size: 10px; letter-spacing: 1.5px;
          text-transform: uppercase; color: #294b5a;
        }
        .st-submit-btn {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 0 32px; height: 48px; border-radius: 12px;
          background: #294b5a; color: #fff; border: none;
          font-family: 'Jost', sans-serif; font-size: 12px; font-weight: 700;
          letter-spacing: 2px; text-transform: uppercase;
          cursor: pointer; transition: background 0.2s, transform 0.2s;
        }
        .st-submit-btn:hover { background: #1a2f38; transform: translateY(-1px); }

        /* POPULAR SECTION */
        .st-popular { background: #faf8f3; padding: 80px 0; }
        .st-popular__eyebrow {
          display: flex; align-items: center; gap: 10px;
          font-size: 11px; font-weight: 600; letter-spacing: 3px;
          text-transform: uppercase; color: #D3BE76; margin-bottom: 10px;
        }
        .st-popular__eyebrow::before { content: ''; width: 28px; height: 1.5px; background: #D3BE76; display: block; }
        .st-popular__title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 34px; font-weight: 700; color: #1a2f38;
        }

        /* DIVIDER */
        .st-divider { height: 1px; background: #e8eef1; margin: 40px 0; }

        @media (max-width: 991px) {
          .st-snapshot { grid-template-columns: repeat(2, 1fr); }
          .st-book-widget { position: static; }
        }
        @media (max-width: 575px) {
          .st-snapshot { grid-template-columns: 1fr 1fr; }
          .st-hero__top { flex-direction: column; }
        }
      `}</style>

      <div className="st-page">
        <div className="header-margin"></div>
        <DefaultHeader />
        <ModalVideo isOpen={isOpen} videoId="oqNZOOWF8qM" setIsOpen={setOpen} />

        {/* ── HERO BAR ── */}
        <div className="st-hero">
          <div className="container">
            <div className="st-hero__top">
              <div>
                <div className="st-hero__eyebrow">{tour?.tourType || "Guided Tour"}</div>
                <h1>{tour?.title}</h1>
                <div className="st-hero__meta">
                  <span className="st-hero__meta-item">
                    {[1,2,3,4,5].map((s) => <i key={s} className="icon-star" style={{ fontSize: 11, color: "#D3BE76" }} />)}
                    <span style={{ marginLeft: 6 }}>{tour?.numberOfReviews} reviews</span>
                  </span>
                  <span className="st-hero__meta-item">
                    <i className="icon-placeholder" />
                    {tour?.location}
                  </span>
                </div>
              </div>
              <div className="st-hero__actions">
                <button className="st-action-btn"><i className="icon-share" style={{ fontSize: 13 }} />Share</button>
                <button className="st-action-btn"><i className="icon-heart" style={{ fontSize: 13 }} />Save</button>
                <button className="st-action-btn" onClick={() => setOpen(true)}><i className="icon-play" style={{ fontSize: 13 }} />Watch</button>
              </div>
            </div>
          </div>

          {/* STICKY NAV */}
          <div className="st-nav">
            <div className="container">
              <div className="st-nav__inner">
                {navTabs.map((tab) => (
                  <button
                    key={tab}
                    className={`st-nav__btn${activeTab === tab ? " active" : ""}`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── MAIN ── */}
        <section style={{ padding: "48px 0 80px", background: "#fff" }}>
          <div className="container">
            <div className="row y-gap-30">

              {/* LEFT COLUMN */}
              <div className="col-xl-8">

                {/* GALLERY */}
                <div className="st-gallery" style={{ borderRadius: 16, overflow: "hidden" }}>
                  <Swiper modules={[Navigation]} loop navigation={{ nextEl: ".st-img-next", prevEl: ".st-img-prev" }}>
                    {tour?.slideImg?.map((slide: string, i: number) => (
                      <SwiperSlide key={i}>
                        <img src={slide} alt={tour?.title} style={{ height: 500, objectFit: "cover", width: "100%" }} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <Gallery>
                    {tour?.slideImg?.map((slide: string, i: number) => (
                      <Item key={i} original={slide} thumbnail={slide} width={451} height={450}>
                        {({ ref, open }) => (
                          <div style={{ position: "absolute", bottom: 20, right: 20, zIndex: 10 }}>
                            <button
                              className="st-gallery__overlay-btn"
                              ref={ref as unknown as React.RefObject<HTMLButtonElement>}
                              onClick={open}
                            >
                              <i className="icon-gallery" style={{ fontSize: 15 }} />
                              See All Photos
                            </button>
                          </div>
                        )}
                      </Item>
                    ))}
                  </Gallery>
                  <button className="section-slider-nav -prev flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none st-img-prev">
                    <i className="icon icon-chevron-left text-12" />
                  </button>
                  <button className="section-slider-nav -next flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none st-img-next">
                    <i className="icon icon-chevron-right text-12" />
                  </button>
                </div>

                {/* SNAPSHOT */}
                <div className="st-snapshot">
                  {snapshots.map((s, i) => (
                    <div key={i} className="st-snapshot__item">
                      <div className="st-snapshot__icon"><i className={s.icon} /></div>
                      <div>
                        <div className="st-snapshot__label">{s.label}</div>
                        <div className="st-snapshot__val">{s.value}</div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* OVERVIEW */}
                <div className="st-divider"></div>
                <div className="st-section-title">Overview</div>
                <p className="st-body-text">
                  Unless you hire a car, visiting Stonehenge, Bath, and Windsor Castle in one day is next to impossible.
                  Designed specifically for travelers with limited time in London, this tour allows you to check off a range
                  of southern England's historical attractions in just one day by eliminating the hassle of traveling between
                  each one independently.
                </p>
                <a href="#" style={{ fontSize: 13, color: "#294b5a", fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", display: "inline-flex", alignItems: "center", gap: 6, marginTop: 12, textDecoration: "none" }}>
                  Show more <i className="icon-arrow-top-right" style={{ fontSize: 12 }} />
                </a>

                <div className="row y-gap-24 mt-32">
                  <div className="col-md-6">
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#294b5a", textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 8 }}>Available Languages</div>
                    <p className="st-body-text">German, Chinese, Portuguese, Japanese, English, Italian, French, Spanish</p>
                  </div>
                  <div className="col-md-6">
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#294b5a", textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 8 }}>Cancellation Policy</div>
                    <p className="st-body-text">For a full refund, cancel at least 24 hours in advance of the start date.</p>
                  </div>
                  <div className="col-12">
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#294b5a", textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 8 }}>Highlights</div>
                    <ul className="st-highlight-list">
                      <li>Travel between UNESCO World Heritage sites aboard a comfortable coach</li>
                      <li>Explore with a guide to delve deeper into the history</li>
                      <li>Great for history buffs and travelers with limited time</li>
                    </ul>
                  </div>
                </div>

                {/* INCLUDED */}
                <div className="st-divider"></div>
                <div className="st-section-title">What's Included</div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="st-included-item"><i className="icon-check check" /><span>Entry ticket to Harry Potter Warner Bros Studio Tour</span></div>
                    <div className="st-included-item"><i className="icon-check check" /><span>Return transfers in air-conditioned coach</span></div>
                  </div>
                  <div className="col-md-6">
                    <div className="st-included-item"><i className="icon-close cross" /><span>Food and drinks</span></div>
                    <div className="st-included-item"><i className="icon-close cross" /><span>Gratuities</span></div>
                    <div className="st-included-item"><i className="icon-close cross" /><span>Digital guide (available at extra cost)</span></div>
                  </div>
                </div>

                {/* IMPORTANT INFO */}
                <div className="st-divider"></div>
                <div className="st-section-title">Important Information</div>
                <div className="row y-gap-20">
                  {[
                    { title: "Inclusions", items: ["Superior Coach with Wi-Fi", "Expert guide", "Admission to Windsor Castle", "Admission to Stonehenge"] },
                    { title: "Exclusions", items: ["Hotel pick-up & drop-off", "Gratuities", "Lunch"] },
                    { title: "Know Before You Go", items: ["Duration: 11 hours", "Mobile tickets accepted", "Instant confirmation"] },
                    { title: "Departure Details", items: ["Departs 8am (board 7:30am)", "Victoria Coach Station Gate 1–5", "164 Buckingham Palace Rd, London"] },
                  ].map((card) => (
                    <div key={card.title} className="col-md-6">
                      <div className="st-info-card">
                        <div className="st-info-card__title">{card.title}</div>
                        <ul className="st-info-list">
                          {card.items.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ITINERARY */}
                <div className="st-divider"></div>
                <div className="row">
                  <div className="col-lg-5">
                    <div className="st-section-title">Itinerary</div>
                    {itineraryContent.map((stop) => (
                      <div key={stop.id} className="st-stop">
                        <div className="st-stop__num">{stop.itemNo}</div>
                        <div>
                          <div className="st-stop__title">{stop.title}</div>
                          <div className="st-stop__sub">60 minutes · Admission included</div>
                          <button className="st-stop__toggle">
                            Details & photo <i className="icon-arrow-top-right" style={{ fontSize: 11 }} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="col-lg-7">
                    <div style={{ borderRadius: 16, overflow: "hidden", height: 380 }}>
                      <GoogleMapReact bootstrapURLKeys={{ key: "" }} defaultCenter={defaultProps.center} defaultZoom={defaultProps.zoom}>
                        <MapMarker lat={59.955413} lng={30.337844} text="Tour Start" />
                      </GoogleMapReact>
                    </div>
                  </div>
                </div>

                {/* REVIEWS */}
                <div className="st-divider"></div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="st-section-title">Guest Reviews</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
                      <div className="st-score-badge">4.8</div>
                      <div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#1a2f38" }}>Exceptional</div>
                        <div style={{ fontSize: 13, color: "#7a9aaa" }}>3,014 reviews</div>
                      </div>
                    </div>
                    {reviewProgress.map((r) => (
                      <div key={r.id} style={{ marginBottom: 14 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                          <span style={{ color: "#4a6370", fontWeight: 500 }}>{r.label}</span>
                          <span style={{ color: "#1a2f38", fontWeight: 700 }}>{r.value}</span>
                        </div>
                        <div className="st-prog-bar">
                          <div className="st-prog-bar__fill" style={{ width: r.pct }} />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="col-lg-8">
                    {[1, 2, 3].map((n) => (
                      <div key={n} className="st-review-item">
                        <div className="st-review__header">
                          <img className="st-review__avatar" src="/img/avatars/2.png" alt="Tonko" />
                          <div>
                            <div className="st-review__name">Tonko</div>
                            <div className="st-review__date">March 2022</div>
                          </div>
                        </div>
                        <div className="st-review__score-pill">★ 9.2 Superb</div>
                        <p className="st-review__text">
                          Nice two level apartment in great London location. Located in a quiet small street,
                          but just 50 meters from the main street and bus stop.
                        </p>
                        {n === 1 && (
                          <Gallery>
                            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", margin: "12px 0" }}>
                              {reviewGalleryImg.map((img, i) => (
                                <Item key={i} original={img} thumbnail={img} width={110} height={110}>
                                  {({ ref, open }) => (
                                    <img src={img} ref={ref} onClick={open} alt="" role="button"
                                      style={{ width: 72, height: 72, borderRadius: 10, objectFit: "cover", cursor: "pointer" }} />
                                  )}
                                </Item>
                              ))}
                            </div>
                          </Gallery>
                        )}
                        <div className="st-review__actions">
                          <button className="st-review__action helpful"><i className="icon-like" style={{ fontSize: 14 }} />Helpful</button>
                          <button className="st-review__action nope"><i className="icon-dislike" style={{ fontSize: 14 }} />Not helpful</button>
                        </div>
                      </div>
                    ))}
                    <div style={{ paddingTop: 20 }}>
                      <a href="#" style={{
                        display: "inline-flex", alignItems: "center", gap: 8,
                        padding: "10px 22px", borderRadius: 10,
                        border: "1.5px solid rgba(41,75,90,0.22)",
                        color: "#294b5a", fontSize: 12, fontWeight: 700,
                        textDecoration: "none", letterSpacing: 1, textTransform: "uppercase"
                      }}>
                        Show all 116 reviews <i className="icon-arrow-top-right" style={{ fontSize: 12 }} />
                      </a>
                    </div>
                  </div>
                </div>

                {/* LEAVE A REPLY */}
                <div className="st-divider"></div>
                <div className="st-section-title">Leave a Reply</div>
                <p style={{ fontSize: 13.5, color: "#7a9aaa", marginTop: -12, marginBottom: 28 }}>Your email address will not be published.</p>
                <form>
                  <div className="row y-gap-20">
                    <div className="col-md-6">
                      <div className="st-form-field"><input type="text" required /><label>Full Name</label></div>
                    </div>
                    <div className="col-md-6">
                      <div className="st-form-field"><input type="email" required /><label>Email Address</label></div>
                    </div>
                    <div className="col-12">
                      <div className="st-form-field"><textarea required rows={5} defaultValue="" /><label>Write your comment</label></div>
                    </div>
                    <div className="col-auto">
                      <button type="submit" className="st-submit-btn">
                        Post Comment <i className="icon-arrow-top-right" style={{ fontSize: 13 }} />
                      </button>
                    </div>
                  </div>
                </form>

              </div>
              {/* END LEFT */}

              {/* BOOKING WIDGET */}
              <div className="col-xl-4">
                <div className="st-book-widget">
                  <div className="st-book-widget__head">
                    <div className="st-book-widget__from">Starting from</div>
                    <div className="st-book-widget__price">
                      US${tour?.price}<span>/ per adult</span>
                    </div>
                  </div>
                  <div className="st-book-widget__body">

                    <div className="st-field">
                      <div className="st-field__label">Select Dates</div>
                      <div className="st-field__val">
                        <DatePicker inputClass="custom_input-picker" containerClassName="custom_container-picker"
                          value={dates} onChange={setDates} numberOfMonths={2} offsetY={10} range rangeHover format="MMM DD" />
                      </div>
                    </div>

                    <div className="st-field" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" data-bs-offset="0,16" style={{ cursor: "pointer" }}>
                      <div className="st-field__label">Travelers</div>
                      <div className="st-field__val">
                        {guestCounts.Adults} adults · {guestCounts.Children} children · {guestCounts.Rooms} room
                      </div>
                      <div className="shadow-2 dropdown-menu min-width-400">
                        <div style={{ background: "#fff", borderRadius: 14, padding: "16px 20px" }}>
                          {counters.map((c) => (
                            <Counter key={c.name} name={c.name} defaultValue={c.defaultValue} onCounterChange={handleCounterChange} />
                          ))}
                        </div>
                      </div>
                    </div>

                    <a href="/booking-page" className="st-book-btn">
                      Book Now — Instant Confirmation
                    </a>

                    <div style={{ textAlign: "center", marginTop: 14, fontSize: 12.5, color: "#7a9aaa" }}>
                      94% of travelers recommend this experience
                    </div>
                  </div>
                  <div className="st-trust">
                    <i className="icon-shield st-trust__icon" />
                    <div className="st-trust__text">Free cancellation up to 24 hours before the experience starts for a full refund.</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>



        <DefaultFooter />
      </div>
    </>
  );
};

export default SingleTrip;